import { ColumnType } from "../components/shared/table/types/tableProps";
import { FiltersTable } from "../contexts/tableContext";
import { formattedDate, getUtc, toUtcQueryDate } from "./dateHelper";

export const toUtcDateFilter = (field: string, value: Date) => {
    const dateFrom = getUtc(value);
    const from = formattedDate(dateFrom);
    const dateTo = new Date(new Date(dateFrom).setUTCHours(24, 0, 0, 0));
    const to = formattedDate(dateTo);
    return ` AND ${field} BETWEEN DATE '${from} 00:00:00' AND DATE '${to} 00:00:00'`;
}

export const filterLocal = (mappedLocal: any[], filtersTable: FiltersTable[]) => {
    if (filtersTable !== undefined && filtersTable != null && filtersTable.length > 0) {
        let filteredLocal: any[] = [];
        var setFilter = false;
        mappedLocal.forEach((element) => {
            let count = 0;
            filtersTable.forEach((value: FiltersTable, index: number) => {
                if (value.filterColumnName && value.filterColumnName !== "" && mappedLocal.length > 0) {
                    if (typeof value.filterColumnValue == "number" && value.filterColumnValue !== 0) {
                        let valueLocal = element[value.filterColumnName!] as number;
                        if (valueLocal.toString().toLowerCase().includes(value.filterColumnValue.toString().toLowerCase())) {
                            count++;
                        }
                    }
                    else if (typeof value.filterColumnValue == "string") {
                        let valueLocal = element[value.filterColumnName!] as string;
                        if (valueLocal != null && valueLocal.toString().toLowerCase().includes(value.filterColumnValue!.toString().toLowerCase())) {
                            count++;
                        }
                    }
                    else if (value.filterType === ColumnType.Date) {
                        let valueLocal = element[value.filterColumnName!];

                        if (valueLocal !== null && valueLocal !== undefined && valueLocal !== "") {
                            const dateFrom = (value.filterColumnValue as Date).getTime();
                            const dateTo = (new Date(new Date(dateFrom).setHours(24, 0, 0, 0))).getTime();
                            if (valueLocal >= dateFrom && valueLocal < dateTo) {
                                count++;
                            }
                        }
                    }
                    else if (value.filterColumnValue === 0) {
                        count++;
                    }
                    setFilter = true;
                }
            });
            if (count === filtersTable.length) {
                filteredLocal.push(element);
            }
        });
        if (setFilter) {
            return filteredLocal;
        }
        else {
            return mappedLocal;
        }
    }
    return mappedLocal;
}

export const filtersToQuery = (filtersTable: FiltersTable[], mainFilter?: string) => {
    const isMainFilter = hasValue(mainFilter);
    var where: string = isMainFilter ? mainFilter as string : "1=1";
    if (filtersTable !== undefined && filtersTable != null) {
        where = "";
        var setFilter = false;
        filtersTable.forEach((value: FiltersTable, index: number) => {
            if (value.filterColumnName && value.filterColumnName !== "") {
                if (index !== 0) where = where + ' AND ';

                if (typeof value.filterColumnValue == "number" || value.filterColumnName === "WZOR" || value.filterColumnName === "NUMER_IDENTYFIKACYJNY") {
                    where = where + `CAST(${value.filterColumnName} AS CHARACTER(20)) LIKE '%${value.filterColumnValue}%'`;
                } else if (value.filterType === ColumnType.Date) {
                    where = where + toQueryDateFilter(value.filterColumnName, value.filterColumnValue as Date);
                } else {
                    where = where + `LOWER(${value.filterColumnName}) LIKE LOWER('%${value.filterColumnValue}%')`;
                }
                setFilter = true;
            }
        });

        if (setFilter) {
            return isMainFilter ? `${mainFilter} AND (${where})` : where;
        } else {
            return isMainFilter ? mainFilter : "1=1";
        }
    }
    return where;
}

export const toQueryDateFilter = (field: string, value: Date) => {
    const dateFrom = value;
    const from = toUtcQueryDate(dateFrom);
    const dateTo = new Date(new Date(dateFrom).setHours(24, 0, 0, 0));
    const to = toUtcQueryDate(dateTo);
    return `${field} BETWEEN DATE '${from}' AND DATE '${to}'`;
}

const hasValue = (value: any) => {
    return value !== undefined && value !== null && value !== "";
}